import { useUser } from '@/services/user';
import { useNotificationsStore } from '@teemill/modules/notifications';
import { useDocumentVisibility, useIdle, useIntervalFn } from '@vueuse/core';
import { computed, ref, watch } from 'vue';

const POLL_INTERVAL_ACTIVE = 10 * 1000; // 10 seconds
const POLL_INTERVAL_INACTIVE = 10 * 60 * 1000; // 10 minutes
const IDLE_INTERVAL = 5 * 60 * 1000; // 5 minutes

export const useNotificationPolling = () => {
  const user = useUser();
  const notificationsStore = useNotificationsStore();
  const { idle } = useIdle(IDLE_INTERVAL);
  const documentVisibility = useDocumentVisibility();
  const fetching = ref(false);

  const fetch = async () => {
    if (fetching.value) {
      return;
    }

    fetching.value = true;

    try {
      const meta = await user.notifications.meta({ search: 'group:user' });
      notificationsStore.unreadCount = meta.unreadCount;
    } catch {
      // Silently fail on meta fetch errors
    } finally {
      fetching.value = false;
    }
  };

  watch(
    () => documentVisibility.value,
    (visibility) => {
      if (visibility === 'visible') {
        fetch();
      }
    },
  );

  useIntervalFn(
    fetch,
    computed(() =>
      documentVisibility.value === 'visible' && !idle.value
        ? POLL_INTERVAL_ACTIVE
        : POLL_INTERVAL_INACTIVE,
    ),
  );

  return {
    start: () => {
      fetch();
    },
    fetch,
  };
};
